import $ from 'jquery';

// prettier-ignore
const main = () => {
    $(() => {

        // click auf die veranstaltungskarte auf der homepage
        $('.container-veranstaltungen .blog-card-image').on('click', function() {
            $(this).parent().find('.blog-card').toggleClass('active').toggleClass('inactive');
        });
        $('.container-veranstaltungen .blog-card-infos .plus').on('click', function() {
            $(this).parent().parent().find('.blog-card').toggleClass('active').toggleClass('inactive');
        });


        // aenderung ansicht zahlart mitgliedschaft
        $('input[type="radio"]').on('click', function() {
            var id = $(this).attr('id');

            $('.mitglied-formular').removeClass('active');
            $('.mitglied-formular.' + id).addClass('active');
        });

        // navbar vergrößern, verkleinern
        $(window).on('scroll', function() {
            if ($(window).scrollTop() > 50) {
                $('.navBar').addClass('scrolled');
            }
            if ($(window).scrollTop() < 1) {
                $('.navBar').removeClass('scrolled');
            }
        });

        // mobile menu
        $('.hamburger, .close, ul li a').on('click', function() {
            //console.log('click hamburger');
            $('.hamburger').toggleClass('open');
            $('.navBar .vertical.menu').toggleClass('hide');
        });

        // scroll-top-button
        $('.totop').on('click', function(e) {
            e.preventDefault();
            console.log('totop');
            $('html, body').animate({ scrollTop: 0 }, 'slow');
        });

        $(window).on('resize', function(){
            $('.blog-card').css('height',$('.blog-card').width()+'px');
        });
        $(window).trigger('resize');



      // browser window scroll (in pixels) after which the "back to top" link is shown
      var offset = 300,
        //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
        offset_opacity = 1200,
        //duration of the top scrolling animation (in ms)
        scroll_top_duration = 700,
        //grab the "back to top" link
        $back_to_top = $('.cd-top');

      //hide or show the "back to top" link
      $(window).scroll(function(){
        ( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
        if( $(this).scrollTop() > offset_opacity ) {
          $back_to_top.addClass('cd-fade-out');
        }
      });

      //smooth scroll to top
      $back_to_top.on('click', function(event){
        event.preventDefault();
        $('body,html').animate({
            scrollTop: 0 ,
          }, scroll_top_duration
        );
      });

    });
};
export default main;




// WEBPACK FOOTER //
// ./src/scripts/modules/main.js